import { useCallback, useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const MANAGER_ROLES = ['admin', 'regional_manager', 'branch_manager'];

// Pushes the live task count to the launcher icon (Android bridge / PWA badge API).
export const setAppBadge = (n) => {
  try { if (window.AndroidBridge && typeof window.AndroidBridge.setAppBadge === 'function') window.AndroidBridge.setAppBadge(Number(n) || 0); } catch (_) { /* noop */ }
  try { if (navigator.setAppBadge) (n > 0 ? navigator.setAppBadge(n) : navigator.clearAppBadge && navigator.clearAppBadge()); } catch (_) { /* noop */ }
};

// Live count of pending Action-page tasks for BM / RM / Admin (polls every 30 s while visible + on focus + on demand).
export function useActionCount(user, token) {
  const eligible = !!(user && token && MANAGER_ROLES.includes(user.role));
  const [count, setCount] = useState(null);
  const refresh = useCallback(async () => {
    if (!eligible) return;
    try {
      const r = await fetch(`${API}/api/actions/count`, { headers: { Authorization: `Bearer ${token}` } });
      if (r.ok) { const d = await r.json(); setCount(d.count); setAppBadge(d.count); }
    } catch (_) { /* keep last value */ }
  }, [eligible, token]);
  useEffect(() => {
    if (!eligible) return undefined;
    refresh();
    const id = setInterval(() => { if (document.visibilityState === 'visible') refresh(); }, 30000);
    const onWake = () => refresh();
    window.addEventListener('focus', onWake);
    window.addEventListener('actions-changed', onWake);
    return () => { clearInterval(id); window.removeEventListener('focus', onWake); window.removeEventListener('actions-changed', onWake); };
  }, [eligible, refresh]);
  return { count: eligible ? count : null, refresh, eligible };
}
